import React from 'react';
import PropTypes from 'prop-types';
import { Routes, Route, useLocation } from 'react-router-dom';

import styled from 'styled-components';

import ZanichelliLogo from '../../../header/assets/zanichelli-logo.svg?react';
import ZLogo from '../../../header/assets/z-logo.svg?react';

import NavigationBar from '../../../navigation-bar';
import { HOMEWORK_EXECUTION, RESULTS, PAUSE, START_PAGE } from '../../../../constants/routes';

import FluidContainer from '../../components/fluid-container';

import NotificationContainer from '../../../../containers/notification-container';
import ColumnContainer from '../../components/column-container';
import Hidden from '../../components/hidden';
import { redirectToSourceHome } from '../../../../lib/utils';

const Logo = styled.img`
    ${(props) => props.isLogoClickable && 'cursor: pointer;'}
    ${(props) => (props.isMobile ? 'position: absolute;' : 'width: 100%;')}
`;

const Bar = ({ applicationStatus, homeworkStatus }) => (
    <ColumnContainer width={[1, 1, 12 / 12]} height={48} bg="surface-grey-200" boxShadow="shadow-01dp" justifyContent="center">
        <ColumnContainer width={[1, 1, 10 / 12]} paddingX={['xs', 'tablet', 'desktop']} style={{ maxWidth: '1152px' }}>
            {applicationStatus.completed && !homeworkStatus.error && <NavigationBar />}
        </ColumnContainer>
    </ColumnContainer>
);

const LightHeader = ({ applicationStatus, homeworkStatus, isEmbedded, isLoading, source, numberOfExercises }) => {
    const location = useLocation();
    const isLogoClickable = !isLoading && !isEmbedded;

    let bottom = [-106, -106, -92];

    if (location.pathname === START_PAGE) {
        bottom = [-50, -20, -20];
    }

    return (
        <FluidContainer position="fixed" top={0} zIndex={1} flexDirection="column">
            {location.pathname === START_PAGE && (
                <>
                    <Hidden below="desktop">
                        <ColumnContainer height={80} backgroundColor="surface-grey-050" boxShadow="shadow-01dp">
                            <ColumnContainer width={[0, 2 / 8, 2 / 12]}>
                                <Logo
                                    src={ZanichelliLogo}
                                    isMobile={false}
                                    isLogoClickable={isLogoClickable}
                                    onClick={isLogoClickable ? () => redirectToSourceHome(source) : null}
                                />
                            </ColumnContainer>
                        </ColumnContainer>
                    </Hidden>

                    <Hidden above="desktop">
                        <ColumnContainer height={44} backgroundColor="surface-grey-050" boxShadow="shadow-01dp">
                            <Logo
                                src={ZLogo}
                                isMobile={true}
                                isLogoClickable={isLogoClickable}
                                height={44}
                                onClick={isLogoClickable ? () => redirectToSourceHome(source) : null}
                            />
                        </ColumnContainer>
                    </Hidden>
                </>
            )}
            {numberOfExercises > 1 && (
                <Routes>
                    <Route
                        path={HOMEWORK_EXECUTION}
                        element={<Bar applicationStatus={applicationStatus} homeworkStatus={homeworkStatus} />}
                    />
                    <Route path={RESULTS} element={<Bar applicationStatus={applicationStatus} homeworkStatus={homeworkStatus} />} />
                    <Route path={PAUSE} element={<Bar applicationStatus={applicationStatus} homeworkStatus={homeworkStatus} />} />
                </Routes>
            )}

            <NotificationContainer bottom={bottom} />
        </FluidContainer>
    );
};

LightHeader.propTypes = {
    applicationStatus: PropTypes.object,
    homeworkStatus: PropTypes.object,
    isEmbedded: PropTypes.bool,
    isLoading: PropTypes.bool,
    source: PropTypes.string,
    numberOfExercises: PropTypes.number,
};

export default LightHeader;
